import HomestayRateList from './HomestayRateList'

export default HomestayRateList